module.exports = __webpack_public_path__ + "static/media/effect-01.e07bba7b.png";